import React, { createContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MESS_TYPES } from '../redux/actions/messageAction';

export const SocketContext = createContext();

const SocketProvider = ({ children }) => {
  const dispatch = useDispatch();
  const socket = useSelector(state => state.socket); // ✅ Accede correctamente
  const auth = useSelector(state => state.auth);

  useEffect(() => {
    if (!socket || typeof socket.on !== 'function') return;

    const handleReceiveMessage = (msg) => {
      const key = `groupMessages-${msg.groupId}`;
      const existing = JSON.parse(localStorage.getItem(key) || '[]');
      const updated = [...existing, msg];
      localStorage.setItem(key, JSON.stringify(updated));

      // 🔥 Notificar al componente Chatgrup de que hay un nuevo mensaje
      window.dispatchEvent(new CustomEvent('new-group-message', {
        detail: { groupId: msg.groupId }
      }));
    };

    socket.on('receiveGroupMessage', handleReceiveMessage);

    return () => {
      socket.off('receiveGroupMessage', handleReceiveMessage);
    };
  }, [socket]);


  return (
    <SocketContext.Provider value={{}}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
